<template>
    <section class="mobile-panel-wrapper" v-on="$listeners">

        <header>
            <slot name="header" />
        </header>

        <article>
            <slot name="content" />
        </article>

        <footer>
            <slot name="footer">

                <div class="control-buttons">
                    <button class="clear-button" @click.prevent="$emit('clear')">Wyczyść filtry</button>
                    <button @click.prevent="$emit('apply')"
                            :class="{ active: active }"
                            data-link="menu"
                            type="submit"
                            class="button button-primary"
                            style="padding-left: 60px; padding-right: 60px;"
                    ><span class="button-title" :data-count="dataCount">Zastosuj filtry</span></button>
                </div>

            </slot>
        </footer>

    </section>
</template>

<script>
    import ButtonBack from "./ButtonBack"

    export default {
        name: "PanelWrapper",
        props: {
            active: Boolean,
            count: Number,
        },
        components: {
            ButtonBack,
        },
        computed: {
            dataCount() {
                return !this.count ? "" : this.count;
            }
        },
    }
</script>

<style scoped lang="scss">
    @import "../../../../../scss/variables";
    @import "../../../../../scss/mixins/breakpoint";

    header {
        margin-bottom: 20px;
    }

    button.clear-button {
        border: none;
        background-color: transparent;
        margin-right: 50px;
        font-size: 16px;
    }

    .mobile-panel-wrapper {
        background-color: #efefef;
        padding: 0;
        width: 100%;
        box-sizing: border-box;
        overflow: auto;

        @include only-mobile-breakpoint() {
            top: $mobileHeaderHeight;
        }

        & footer {
            background-color: transparent;

            & .control-buttons {
                box-shadow: #666666 3px 8px 10px;
                padding: 20px 100px 20px 0;
                position: fixed;
                width: 100%;
                text-align: center;
                box-sizing: border-box;
                bottom: 0;
                border-top: 1px solid #efefef;
                background-color: #ffffff;
                z-index: 3;

                &:after {
                    content: '';
                    display: table;
                    clear: both;
                }

                .button-title {
                    &:not([data-count=""]):after {
                        display: inline-block;
                    }
                    &:not([data-count]):after {
                        display: none;
                    }

                    &:after {
                        display: none;
                        position: absolute;
                        content: attr(data-count);
                        background: #22770e;
                        margin: 0 0 0 10px;
                        top: -10px;
                        min-width: 21px;
                        min-height: 21px;
                        line-height: 21px;
                        border-radius: 50%;
                        color: white;
                        font-size: 14px;
                        font-style: normal;
                        text-align: center;
                        transform: scale(1);
                        transition: 300ms;

                        @keyframes scale-counter {
                            0% {
                                transform: scale(1);
                            }
                            50% {
                                transform: scale(1.3);
                            }
                            100% {
                                transform: scale(1);
                            }
                        }
                    }
                }
            }

            & .mobile-apply {
                color: #333333;
                background-color: #eeeeee;
                border: 1px solid #666666;
                width: 100%;
                max-width: 290px;
                padding: 15px;
                font-size: 16px;
                position: relative;
                align-items: center;
                -webkit-align-items: center;
                justify-content: center;
                -webkit-justify-content: center;
                text-align: center;
                cursor: pointer;

                &:hover,
                &.active:hover {
                    color: #ffffff;
                    background: #0E0E0E;
                    border: 1px solid #0E0E0E;
                }
                &.active {
                    color: #ffffff;
                    background: #1E1E1E;
                    border: 1px solid #1E1E1E;
                }
            }
        }
    }

    @include only-mobile-breakpoint() {
        .mobile-panel-wrapper footer .control-buttons {
            padding: 10px 0;
        }
        .mobile-panel-wrapper footer button.mobile-apply {
            width: 50%;
            padding: 10px 0;
        }
        button.clear-button {
            margin-right: 10px;
            margin-top: 10px;
            font-size: 14px;
        }
    }

</style>
